<template>
    <div class="mask-clip" @click="handleClose">
        <div class="popup-content" @click.stop="null">
            <!-- 上层 -->
            <div class="popup-content-top">
                <div class="popup-content-top-bg"></div>
                <img class="popup-content-top-icon" :src="ticket?.img">
                <div class="popup-content-top-bottomIcon"></div>
                <!-- close -->
                <div class="close-view" @click="handleClose">
                    <div class="close-view-icon">
                        <img class="close-view-icon-close" src="@/assets/images/YuliApp/LM_EVENT/HK_DIRL_EVENT/popup_close_btn.png">
                    </div>
                </div>
            </div>
            <!-- 中间层 -->
            <div class="popup-content-middle">
                <div class="popup-content-middle-title">{{ ticket?.name }}</div>
                <div class="popup-content-middle-desc">{{ ticket?.desc }}</div>
                <div class="popup-content-middle-line"></div>
                <div class="popup-content-middle-linkDesc">Go to the website below to claim your HONG KONG DIRL PASS and redeem your reward.</div>
                <div class="popup-content-middle-linkView" @click="copyLinkHandle">
                    <div class="popup-content-middle-linkView-left">
                        <div class="popup-content-middle-linkView-left-title">Copy website address</div>
                        <div class="popup-content-middle-linkView-left-desc">{{ ticket?.url }}</div>
                    </div>
                    <div class="popup-content-middle-linkView-icon"></div>
                </div>
            </div>
            <!-- 底部 -->
            <div class="popup-content-bottom"></div>
        </div>
    </div>
</template>

<script>
import { onMounted, ref, getCurrentInstance } from "vue";
import { mapState } from "vuex";
import { TOAST_TYPE } from "@/components/Toast/index.vue";

export default {
components: {
},
props: {
    ticket: {
        type: Object,
        default: () => {
            return {}
        },
    },
},
computed: {
    ...mapState({
        init: (state) => state.global.init,
        statusBarHeight: (state) => state.global.statusBarHeight,
    }),
},
setup(props, ctx) {
    const { proxy } = getCurrentInstance();
    onMounted(() => {
        
    });

    /**
     * 处理关闭
     */
     const handleClose = () => {
      ctx.emit("msgHandle", false);
    };

    const copyLinkHandle = () => {
        const url = props?.ticket?.url;
        const copyLinkHandle2 = () => {
            const textArea = document.createElement("textarea");
            textArea.value = url;

            textArea.style.top = "-200";
            textArea.style.left = "0";
            textArea.style.position = "fixed";
            textArea.style.opacity = "0"

            document.body.appendChild(textArea);
            textArea.select();
            try {
                const successful = document.execCommand("copy");
                proxy.$toast.show({
                    msg: 'Copied successfully',
                    type: TOAST_TYPE.SUCCESS,
                })
            } catch (err) {
                proxy.$toast.show({
                    msg: 'Copy failed',
                    type: TOAST_TYPE.ERROR,
                })
            }
            document.body.removeChild(textArea);            
        }
        navigator.clipboard.writeText(url).then(function() {
            proxy.$toast.show({
                msg: 'Copied successfully',
                type: TOAST_TYPE.SUCCESS,
            })
        }).catch(function(err) {
            copyLinkHandle2();
        });
    }

    return {
        handleClose,
        copyLinkHandle,
    };
},
};
</script>

<style lang="less">
.mask-clip{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 999;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
}
.popup-content{
    width: 343px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    &-top{
        width: 100%;
        height: 120px;
        position: relative;
        &-icon{
            width: 100px; 
            height: 100px;
            position: absolute;
            top: 10px;
            right: 10px;
        }
        &-bg{
            position: absolute;
            z-index: 0;
            width: 100%;
            height: 100%;
            background: url("~@/assets/images/YuliApp/LM_EVENT/HK_DIRL_EVENT/item_bg_top.png")
            no-repeat top left;
            background-size: 100% 100%;
        }
        .close-view{
            position: absolute;
            z-index: 999;
            width: fit-content;
            right: 0;
            top: -40px;
            &-icon{
                width: 26px;
                height: 26px;
                &-close{
                    width: 26px;
                    height: 26px;
                }
            }
        }
        &-bottomIcon{
            position: absolute;
            z-index: 0;
            width: 100%;
            height: 15px;
            background: url("~@/assets/images/YuliApp/LM_EVENT/HK_DIRL_EVENT/popup_bg_top.png")
            no-repeat top left;
            background-size: 100% 100%; 
            bottom: -1.5px;
        }
    }
    &-middle{
        width: 100%;
        box-sizing: border-box;
        height: fit-content;
        padding: 16px;
        background-color: #010000;
        @borderW: 1px;
        border-left: @borderW solid #FF2718;
        border-right: @borderW solid #FF2718;
        font-family: "Noto Sans S Chinese";
        font-style: normal;
        text-align: left;
        color: #D3443A;
        &-title{
            color: #ff2718;
            font-size: 18px;
            font-weight: 700;
            line-height: 27px;
            margin-bottom: 8px;
        }
        &-desc{
            white-space: pre-line;
            font-size: 14px;
            font-weight: 400;
            line-height: 21px;
        }
        &-line{
            width: 100%;
            height: 1px;
            background-color: #FF2718;
            margin-top: 16px;
            margin-bottom: 15px;
        }
        &-linkDesc{
            font-size: 14px;
            font-weight: 400;
            line-height: 21px;
            margin-bottom: 8px;
        }
        &-linkView{
            width: 100%;
            height: 86px;
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            padding: 14px;
            background-color: #340808;
            color: #FF2718;
            font-size: 12px;
            &-left{
                &-title{
                    font-weight: 700;
                    margin-bottom: 4px;
                }
                &-desc{
                    word-break: break-all;
                    max-width: 211px;
                    font-weight: 400;
                    line-height: 18px;
                }
            }
            &-icon{
                width: 48px;
                height: 48px;
                background: url("~@/assets/images/YuliApp/LM_EVENT/HK_DIRL_EVENT/icon_link.png")
                no-repeat top left;
                background-size: 100% 100%;
            }
        }
    }
    &-bottom{
        width: 100%;
        height: 18px;
        background: url("~@/assets/images/YuliApp/LM_EVENT/HK_DIRL_EVENT/item_bg_bottom.png")
        no-repeat top left;
        background-size: 100% 100%;
        margin-top: -3px;
    }
}
@media screen and (max-height: 720px) {
    .popup-content{
        &-middle{
            padding-top: 4px;
            padding-bottom: 10px;
            &-title{
                font-size: 16px;
                margin-bottom: 6px;
            }
            &-desc{
                font-size: 13px;
            }
            &-line{
                width: 100%;
                height: 1px;
                background-color: #FF2718;
                margin-top: 10px;
                margin-bottom: 10px;
            }
            &-linkDesc{
                font-size: 13px;
                margin-bottom: 4px;
            }
            &-linkView{
                width: 100%;
                height: 66px;
                padding: 14px;
                padding-top: 7px;
                padding-bottom: 7px;
                &-icon{
                    width: 42px;
                    height: 42px;
                }
            }
        }
        
    }
}
</style>